import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
  useTheme,
  alpha,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useCourseEnrollableTurmas } from "../../api/getCourseEnrollableTurmas";
import * as yup from "yup";
import { Close, ExpandMore } from "@mui/icons-material";
import Form from "../../../../ui/components/Form";
import moment from "moment";
import { useEnrollToCourseTurma } from "../../api/enrollToCourseTurma";
import { baseUrl } from "../../../../shared/config";
import clsx from "clsx";
import { createNotification } from "../../../../shared/store/notifications";
import { useRegisterGameficationScore } from "../../../gamefication/api/registerGameficationScore";
import { checkNeedValidateCon } from "../../../../shared/store/auth";
import { cn } from "../../../../shared/utils/cn";

const useStyles = makeStyles((theme) => ({
  Label: {
    paddingTop: theme.spacing(1),
    fontSize: "15px",
    fontWeight: "500",
  },
  ErrorLabel: {
    color: "red",
  },
  TurmaOption: {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
    padding: theme.spacing(1),
    cursor: "pointer",
    borderRadius: "4px",
  },
  Disabled: {
    color: theme.palette.action.disabled,

    cursor: "none",
    pointerEvents: "none",
    boxShadow: "initial",
  },

  Active: {
    backgroundColor: alpha(theme.palette.primary.light, 0.5),
  },
  Enrolled: {
    border: `2px solid ${theme.palette.primary.main}`,
    color: "initial",
  },
  OptionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "max-content",

    gap: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  },
}));

const schema = yup.object().shape({
  turmaId: yup.number().required("Escolha uma turma"),
});

const renderTurmaStatus = (turma) => {
  switch (turma.situacao) {
    case "Disponível":
      if (turma.limite_vagas === 0) {
        return (
          <span className="font-medium text-green-600">Vagas Ilimitadas</span>
        );
      }
      return (
        <span className="font-medium text-green-600">
          {turma.vagas_disponiveis} Vagas Disponíveis
        </span>
      );

    default:
      return turma.situacao;
  }
};

const PickTurma = ({ course, children }) => {
  const courseId = course.disciplinaid;
  const { data, isFetching } = useCourseEnrollableTurmas({ courseId });
  const classes = useStyles();
  const theme = useTheme();
  const isDisplaySmall = useMediaQuery(theme.breakpoints.down("md"));
  const enrollMutation = useEnrollToCourseTurma({ courseId });
  const registerScore = useRegisterGameficationScore();
  const [dialogOpen, setDialogOpen] = useState(false);
  const methods = {
    openDialog: () => {
      setDialogOpen(true);
    },
    closeDialog: () => {
      setDialogOpen(false);
    },
  };
  const handleSubmit = (values) => {
    enrollMutation.mutate(
      { ...values, courseId },
      {
        onSuccess: () => {
          createNotification({ type: "sucess", message: "Matrícula criada" });
          methods.closeDialog();
          registerScore.mutate({
            type: "INICIOU_CURSO",
            details: "Matrícula auto-inscrição",
            ref: 1,
          });
        },
      }
    );
  };

  return (
    <>
      {children(methods)}

      <Dialog
        open={dialogOpen}
        maxWidth="md"
        fullWidth
        fullScreen={isDisplaySmall}
      >
        <IconButton
          sx={{ position: "absolute", top: 3, right: 3 }}
          onClick={methods.closeDialog}
        >
          <Close />
        </IconButton>

        <DialogContent>
          <span className="flex flex-row items-center gap-2 pb-2">
            <Avatar src={`${baseUrl}/Membros/fotos/${course.foto}`} />
            <Typography sx={{ fontWeight: "600" }}>{course.curso}</Typography>
          </span>
          <div className="flex flex-col md:flex-row gap-1">
            <Typography variant="caption">
              <span className="text-gray-500">Categoria: </span>
              {course.categoria}
            </Typography>
            <Typography variant="caption">
              <span className="text-gray-500">Duração: </span>
              {course.duracao_dias} dias
            </Typography>
            <Typography variant="caption">
              <span className="text-gray-500">Carga horária: </span>
              {course.carga_horaria}
            </Typography>
            <Typography variant="caption">
              <span className="text-gray-500">Valor: </span>
              {(Math.round(course.valor_venda * 100) / 100).toFixed(2)}
            </Typography>
          </div>
          <Accordion defaultExpanded={false}>
            <AccordionSummary
              sx={{
                ".MuiAccordionSummary-content": {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "500",
                },
              }}
            >
              <Typography
                color="primary"
                fontWeight={"600"}
                textTransform={"uppercase"}
              >
                ver conteúdo do curso
              </Typography>
              <ExpandMore color="primary" />
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  fontSize: "0.8rem",
                }}
                dangerouslySetInnerHTML={{
                  __html: course.conteudo,
                }}
              />
            </AccordionDetails>
          </Accordion>
          <Form schema={schema} onSubmit={handleSubmit}>
            {(formMethods) => {
              const currentValue = formMethods.watch("turmaId");
              const handleClickOption = (value) => () => {
                formMethods.setValue("turmaId", value, {
                  shouldDirty: true,
                });
              };

              const handleUnselect = () => {
                formMethods.setValue("turmaId", undefined, {
                  shouldDirty: true,
                });
              };
              return (
                <>
                  {isFetching ? (
                    <div className="flex items-center justify-center w-full p-3">
                      {" "}
                      <CircularProgress />{" "}
                    </div>
                  ) : (
                    <>
                      <label
                        className={clsx(
                          classes.Label,
                          !!formMethods.formState?.errors?.turmaId?.message &&
                            classes.ErrorLabel
                        )}
                      >
                        Escolha uma turma
                      </label>
                      <div className={classes.OptionsGrid}>
                        {data?.map((turma, index) => {
                          const isDisabled = () => {
                            return turma.situacao !== "Disponível";
                          };
                          const isPicked = () => {
                            return turma.turmaid === currentValue;
                          };
                          const isAlreadyEnrolled = () => {
                            return turma.situacao === "Matriculado";
                          };
                          const aulasArray = turma.AULAS.split(",");
                          return (
                            <Stack
                              onClick={
                                isPicked()
                                  ? handleUnselect
                                  : handleClickOption(turma.turmaid)
                              }
                              className={clsx(
                                classes.TurmaOption,
                                isDisabled() && classes.Disabled,
                                isPicked() && classes.Active,
                                isAlreadyEnrolled() && classes.Enrolled
                              )}
                            >
                              <Typography>
                                {turma.nome_turma} -{" "}
                                <span
                                  className={cn({
                                    "text-orange-500":
                                      isDisabled() && !isPicked(),
                                  })}
                                >
                                  {renderTurmaStatus(turma)}
                                </span>
                              </Typography>
                              <Typography variant="caption">
                                Começa:{" "}
                                {moment(
                                  turma.datainicio,
                                  "YYYY-MM-DD[T]HH:mm:ss"
                                ).format("ll")}{" "}
                              </Typography>
                              <Typography variant="caption">
                                Acaba:{" "}
                                {moment(
                                  turma.dataencerramento,
                                  "YYYY-MM-DD[T]HH:mm:ss"
                                ).format("ll")}
                                &nbsp;
                              </Typography>

                              <Divider className="w-full" />
                              <ul>
                                <Typography className="text-xs font-semibold">
                                  Aulas:
                                </Typography>
                                {aulasArray.map((aula) => {
                                  return (
                                    <li>
                                      <Typography variant="caption">
                                        {aula}
                                      </Typography>
                                    </li>
                                  );
                                })}
                              </ul>
                            </Stack>
                          );
                        })}
                      </div>
                      <DialogActions>
                        <Button
                          type="submit"
                          disabled={enrollMutation.isLoading || !currentValue}
                        >
                          {course.JaMatriculado === "Sim"
                            ? "Alterar Minha Turma"
                            : "Matricular-me"}
                        </Button>
                      </DialogActions>
                    </>
                  )}
                </>
              );
            }}
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PickTurma;
